import styles from './css/InfoColumn.css';

import React from 'react';
import { getMessage } from '../../i18n/i18nWrapper';

const InfoColumn = () => {

  return (
    <div className={styles.infoColumn}>
      <div className={styles.toolsMessage}>
        {getMessage('infoColumn.title')}
      </div>
      <div>
        <img src="./static/images/all-my-data-in-one-place.svg" />
        <div>
          <label>{getMessage('infoColumn.label1')}</label>
          <p>{getMessage('infoColumn.blurb1')}</p>
        </div>
      </div>
      <div>
        <img src="./static/images/simplified-field-insights.svg" />
        <div>
          <label>{getMessage('infoColumn.label2')}</label>
          <p>{getMessage('infoColumn.blurb2')}</p>
        </div>
      </div>
      <div>
        <img src="./static/images/optimized-seeding-and-fertility.svg" />
        <div>
          <label>{getMessage('infoColumn.label3')}</label>
          <p>{getMessage('infoColumn.blurb3')}</p>
        </div>
      </div>
    </div>
  );
};

export default InfoColumn;
